import aws from 'assets/img/common/aws-logo.png'

export const courseSupport = {
  paragraph: 'We are grateful for the support and partnership of',
  logo: [
    {
      src: aws,
      alt: 'Amazon Web Services',
    },
  ],
}
